import type { TIrrigationDeviceStatus } from 'App/Map/types'
import moment from 'moment-timezone'

export type TIrrigationActivityInterval = {
  startTime: string
  endTime: string
  status: TIrrigationDeviceStatus | null
}

export const getIntervalForCurrentStamp = ({
  currentTimeStamp,
  intervals,
  timezone,
}: {
  currentTimeStamp: number | string
  intervals: TIrrigationActivityInterval[]
  timezone: string
}) => {
  const match = intervals.find(
    (i) =>
      i.status !== 'error' &&
      moment
        .tz(currentTimeStamp, timezone)
        .isBetween(i.startTime, i.endTime || moment.tz(timezone), undefined, '[)'),
  )

  return {
    start: match?.startTime ? moment.tz(match.startTime, timezone).startOf('minute') : null,
    end: match?.endTime ? moment.tz(match.endTime, timezone).startOf('minute') : null,
    status: match?.status || 'unknown',
  }
}
